/** Sidebar — Birleşik Yeni Merkezler (Aras uyumlu, sadeleştirilmiş) */
export const YENI_SIDEBAR = {
    key: "Yeni",
    items: [
        {
            path: "/yeni/dosya-operasyon-merkezi",
            title: "Dosya Operasyon",
            icon: "Radar",
            description: "Supreme Ops, zaman aşımı, dosya sağlığı ve pazarlık",
        },
        {
            path: "/yeni/tahkim-merkezi",
            title: "Tahkim Merkezi",
            icon: "Scale",
            description: "Kanban, ön tahkim, hatırlatmalar ve toplu işlem",
        },
        {
            path: "/yeni/icra-merkezi",
            title: "İcra Merkezi",
            icon: "Hammer",
            description: "İcra takibi, kanban ve tahsilat entegrasyonu",
        },
        {
            path: "/yeni/iletisim-merkezi",
            title: "İletişim Merkezi",
            icon: "MessageCircle",
            description: "WhatsApp, e-posta ve müvekkil portalı",
        },
        {
            path: "/yeni/deger-kaybi-merkezi",
            title: "Değer Kaybı Merkezi",
            icon: "Calculator",
            description: "Gelişmiş hesap, ön hesap, kalibrasyon ve kayıtlar",
        },
        {
            path: "/yeni/rayic-parca-merkezi",
            title: "Rayiç & Parça",
            icon: "TrendingDown",
            description: "Rayiç istihbarat, OEM, Bilus ve hasar uzmanı",
        },
        {
            path: "/yeni/finans-merkezi",
            title: "Finans Merkezi",
            icon: "Wallet",
            description: "Kasa, ödeme raporları, kar/zarar ve defterler",
        },
        {
            path: "/yeni/araci-merkezi",
            title: "Aracılar Merkezi",
            icon: "Users",
            description: "Lead, hakediş, bildirim ve komuta",
        },
        {
            path: "/yeni/filo-merkezi",
            title: "Filo Merkezi",
            icon: "LayoutGrid",
            description: "Filo operasyon, hasar ve SLA",
        },
        {
            path: "/filo/canli-destek",
            title: "Filo Canlı Destek",
            icon: "Headset",
            description: "Filo portal canlı sohbet",
        },
        {
            path: "/yeni/aktuerya-merkezi",
            title: "Aktüerya Merkezi",
            icon: "FileText",
            description: "TRH-2010, rant, SİG/DYK ve bilirkişi PDF",
        },
        {
            path: "/yeni/yatar-bedeli-merkezi",
            title: "Yatar Bedeli",
            icon: "Car",
            description: "Mahrumiyet / ikame araç ön hesap ve PDF",
        },
        {
            path: "/yeni/kusur-sorgulama",
            title: "Kusur Sorgulama",
            icon: "BadgePercent",
            description: "Tutanak/foto/video ile AI kusur oranı",
        },
        {
            path: "/yeni/site-yonetimi",
            title: "Site Yönetimi",
            icon: "Globe",
            description: "Slider, haberler, istatistikler ve web başvuruları",
        },
        {
            path: "/yeni/sistem-gunlugu",
            title: "Sistem Günlüğü",
            icon: "Activity",
            description: "Denetim, WA logları ve AI görev kayıtları",
        },
        {
            path: "/yeni/yetki-sablonlari",
            title: "Yetki Şablonları",
            icon: "ShieldCheck",
            description: "Rol bazlı menü ve işlem yetkileri",
        },
    ],
};

export default YENI_SIDEBAR;
